import axios from "axios";
import store from "@/plugin/store";

// create default options for Cognito idp
const region = process.env.VUE_APP_COGNITO_REGION;
const clientId = process.env.VUE_APP_COGNITO_CLIENT_ID;
const idpBaseURL = `https://${process.env.VUE_APP_COGNITO_URL}.auth.${region}.amazoncognito.com`;
const redirect = process.env.VUE_APP_URL + "/auth";

// create base axios client
const idpClient = axios.create({
    baseURL: `${idpBaseURL}/oauth2`,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
});
idpClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if ([400, 403, 401].indexOf(error.response.status) !== -1) {
            store.clear();
        }
        return Promise.reject(error);
    }
);

const idpModule = {
    loginURL: `${idpBaseURL}/authorize?client_id=${clientId}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid&redirect_uri=${redirect}`,
    logoutURL: `${idpBaseURL}/logout?client_id=${clientId}&logout_uri=${process.env.VUE_APP_URL}`,

    install(app) {
        app.config.globalProperties.$idp = this;
    },
    getLoginURL(state = null) {
        if (state != null && state.trim().length !== 0) {
            return `${this.loginURL}&state=${window.btoa(state)}`;
        }
        return this.loginURL;
    },
    getAuthenticator(authorizationCode, refreshToken) {
        if (authorizationCode == null && refreshToken == null) {
            return Promise.reject("authorizationCode and refreshToken are null");
        }

        let payload = {client_id: clientId, redirect_uri: redirect};
        if (refreshToken) {
            payload.grant_type = "refresh_token";
            payload.refresh_token = refreshToken;
        } else if (authorizationCode) {
            payload.grant_type = "authorization_code";
            payload.code = authorizationCode;
        }

        return idpClient.post("/token", payload).then((resp) => {
            let id = resp.data.id_token;
            let access = resp.data.access_token;
            let r = refreshToken != null ? refreshToken : resp.data.refresh_token;
            store.setTokens(id, access, r);
        });
    }
};
export default idpModule;
